<div class="content">
  <!-- Language Switcher -->
  <div class="lang-switcher">
    <button class="lang-btn" [matMenuTriggerFor]="langMenu">
      <img
        class="flag-icon"
        [src]="'/assets/icons/' + util.currentLang + '.webp'"
      />
      <span>{{ "lang." + util.currentLang | translate }}</span>
      <mat-icon class="arrow-icon">keyboard_arrow_down</mat-icon>
    </button>
    <mat-menu #langMenu="matMenu">
      <button
        (click)="util.setDefaultLang(lang)"
        mat-menu-item
        *ngFor="let lang of util.availableLangs"
      >
        <img
          class="mat-icon flag"
          [src]="'/assets/icons/' + lang + '.webp'"
          [alt]="'flag ' + lang"
        />
        {{ "lang." + lang | translate }}
      </button>
    </mat-menu>
  </div>
  <div class="right-side">
    <div class="box-content">
      <div class="header">
        <div class="logo"></div>
        <div class="app-name">
          <h1>{{ "project.nssf" | translate }}</h1>
          <p>{{ "project.sub_nssf" | translate }}</p>
        </div>
        <div class="main-title">
          <p>{{ "project.title" | translate }}</p>
          <div class="version">
            <h2>{{ "about_us.version" | translate }} {{ version }}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="left-side">
    <div class="box-content">
      <div class="header">
        <h1 class="title">{{ "project.welcome" | translate }}</h1>
      </div>

      <form
        *ngIf="!IS_ENABLE_OAUTH"
        class="mt-0"
        [formGroup]="loginForm"
        (ngSubmit)="onSubmit()"
      >
        <div class="row-login text-left">
          <div class="form-group-login col-md-12 pl px-0">
            <label class="label-control">{{
              "user.username" | translate
            }}</label>
            <div class="m-form form-group mb-0">
              <input
                type="text"
                class="form-control"
                [placeholder]="'user.username' | translate"
                formControlName="username"
                autocomplete="off"
                required
              />
              <mat-icon
                class="icon-prefix m-0 custom-icon"
                svgIcon="mail"
              ></mat-icon>
            </div>
            <div class="spacer">
              <mat-error
                *ngIf="
                  loginForm.get('username')?.touched &&
                  loginForm.get('username')?.hasError('required')
                "
              >
                {{ "login.required_username" | translate }}
              </mat-error>
            </div>
          </div>
        </div>
        <div class="row-login text-left">
          <div class="form-group-login col-md-12 pl px-0">
            <label class="label-control">{{
              "login.password" | translate
            }}</label>
            <div class="m-form form-group mb-0">
              <input
                type="text"
                class="form-control"
                [placeholder]="'login.password' | translate"
                [type]="hide ? 'password' : 'text'"
                formControlName="password"
                autocomplete="new-password"
                required
              />
              <mat-icon
                class="icon-prefix m-0 custom-icon"
                svgIcon="pass"
              ></mat-icon>
              <button
                type="button"
                mat-icon-button
                class="icon-suffix mat-button-reset"
                (click)="hide = !hide"
              >
                <mat-icon class="m-0 svg-icon">
                  {{ hide ? "visibility_off" : "visibility" }}
                </mat-icon>
              </button>
            </div>
            <div class="spacer">
              <mat-error
                *ngIf="
                  loginForm.get('password')?.touched &&
                  !loginForm.get('password')?.valid
                "
              >
                {{ "login.required_password" | translate }}
              </mat-error>
            </div>
          </div>
        </div>
        <div class="row-login mb-0">
          <div class="col-md-12 px-0">
            <button type="submit" mat-flat-button class="btn-login">
              {{ "button.login" | translate }}
              <mat-icon
                class="m-0 svg-icon"
                svgIcon="next"
                iconPositionEnd
              ></mat-icon>
            </button>
          </div>
        </div>
      </form>

      <div *ngIf="IS_ENABLE_OAUTH" class="row-login mb-0">
        <div class="col-md-12 px-0">
          <button
            type="submit"
            mat-flat-button
            class="btn-login oauth-btn-login"
            (click)="onLogin()"
          >
            {{ "button.login" | translate }}
            <mat-icon
              class="svg-icon"
              svgIcon="next"
              iconPositionEnd
            ></mat-icon>
          </button>
        </div>
      </div>

      <div class="login-divider">
        <span class="divider-line"></span>
        <span class="divider-text">OR</span>
        <span class="divider-line"></span>
      </div>

      <div class="register-section text-center">
        <a routerLink="/login/user-register" class="btn-register">
          <mat-icon class="register-icon">domain_add</mat-icon>
          <span>{{ "project.register" | translate }}</span>
        </a>
      </div>

      <div class="version mt-5">
        <h2>{{ "about_us.version" | translate }} {{ version }}</h2>
      </div>
    </div>
  </div>
</div>
